"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProjectInfoChip = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(1),
      border: "1px solid ".concat(theme.palette.primary.light)
    }
  };
});

var ProjectInfoChip = function ProjectInfoChip(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: (0, _clsx.default)(classes.root, className),
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    align: "center"
  }, children));
};

exports.ProjectInfoChip = ProjectInfoChip;
ProjectInfoChip.propTypes = {// children: PropTypes.string.isRequired
};
var _default = ProjectInfoChip;
exports.default = _default;